
















import Card from '@/components/Card.vue';
import { createComponent } from '@vue/composition-api';

export default createComponent({
  name: 'SelectCard',
  components: { Card },
  props: {
    options: { type: Array as () => string[], required: true },
    value: { type: String, required: true },
    title: { type: String, required: true },
  },
});
